<script setup lang="ts">
import { computed, ref } from 'vue'
import { Leaf, Sparkles } from 'lucide-vue-next'
import type { AppLocale } from '@/i18n/messages'
import { isIdleMotionActive, useAdventureMotion } from '@/ui/adventure-motion'
import { STREAM_ASSETS, type StreamHudData } from '@/ui/stream-hud'
import AdventureMetric from './AdventureMetric.vue'
import AdventureProgress from './AdventureProgress.vue'

const props = defineProps<{ data: StreamHudData; locale: AppLocale; preview?: boolean }>()
const root = ref<HTMLElement>()
const failed = ref(false)
const mushroom = new URL(STREAM_ASSETS.mushroom, window.location.href).href
const motionActive = computed(() => isIdleMotionActive(props.data.status))
const feedback = useAdventureMotion(root, () => ({ data: props.data, skin: 'stream-mushroom', preview: props.preview }))
</script>

<template>
  <div ref="root" class="adventure-composition mushroom-journal" :data-feedback="feedback" :data-motion-active="motionActive" :data-preview="preview" :data-no-buddy="failed" data-stream-measure>
    <div v-if="!failed" class="mushroom-garden" data-tier="3" aria-hidden="true">
      <span class="mushroom-spores"><i /><i /><i /></span>
      <span class="adventure-companion mushroom-buddy"><img class="mushroom-sway" :src="mushroom" width="63" height="61" alt="" draggable="false" @error="failed = true"></span>
      <span class="mushroom-soil"><Leaf /><i /><Leaf /></span>
    </div>
    <section class="mushroom-note" data-stream-measure>
      <div class="mushroom-cap-trim" data-tier="5" aria-hidden="true"><i /><i /><i /><i /></div>
      <div class="mushroom-note-heading" data-tier="1" data-stream-measure>
        <span class="adventure-level" data-stream-measure>Lv. <b>{{ data.level }}</b></span>
        <Leaf data-feedback-accent aria-hidden="true" />
      </div>
      <AdventureMetric kind="exp" :data="data" :locale="locale" />
      <AdventureProgress variant="mushroom" :data="data" :locale="locale" />
    </section>
    <aside v-if="data.enabled.mesos" class="mushroom-tag" data-tier="2" data-stream-measure>
      <span class="mushroom-tag-loops" aria-hidden="true"><i /><i /></span>
      <AdventureMetric kind="mesos" :data="data" :locale="locale" />
    </aside>
    <span class="adventure-celebration mushroom-celebration" data-tier="3" aria-hidden="true">
      <span v-for="particle in 6" :key="particle" data-feedback-particle><Sparkles v-if="particle % 2" /><Leaf v-else /></span>
    </span>
  </div>
</template>
